export default class Validation {
    constructor() {
        this.messages = {};
    }

    getMessage(feild) {
        if (this.messages[`${feild}`]) {
            return this.messages[`${feild}`][0];
        }

        return null;
    }

    setMessages(messages) {
        this.messages = messages;
    }

    empty() {
        this.messages = {};
    }
}
